module.exports = __webpack_public_path__ + "static/media/asertywnosc.6468687a.jpg";